module.exports = __webpack_public_path__ + "img/bg_8@2x.6e05a1ce.svg";